/**
 * Banner API (BrightLaptopUI)
 * Fetches active banners for the home page carousel.
 */
import axiosInstance from "./axiosConfig";

/**
 * Get all active banners sorted by order
 * @returns {Promise<{ success: boolean, banners: Array }>}
 */
export const getBanners = async () => {
  try {
    const response = await axiosInstance.get("/laptops/banners");
    return {
      success: true,
      banners: response.data?.data?.banners || [],
    };
  } catch (error) {
    // Fail silently — if banners can't be fetched, carousel simply won't show
    console.error("Banner API error:", error.message);
    return { success: false, banners: [] };
  }
};
